import { I_QREditorFormTemplate } from "@/data/types/pages";
import { getRuleErrorMessage } from "@/utils/formHelper";
import { qrNameValidation } from "./shared";
import { EMAIL_PATTERN } from "./patterns";
import { TFunction } from "i18next";

export const qrEmailValidation = (data: I_QREditorFormTemplate, t: TFunction) => {
  return [
    qrNameValidation(t),
    {
      name: "email",
      rules: {
        pattern: {
          value: EMAIL_PATTERN,
          message: getRuleErrorMessage("email", "pattern", data),
        },
        required: {
          value: true,
          message: getRuleErrorMessage("email", "required", data),
        },
        maxLength: {
          value: 70,
          message: getRuleErrorMessage("email", "maxLength", data),
        },
      },
    },
    {
      name: "subject",
      rules: {
        maxLength: {
          value: 100,
          message: getRuleErrorMessage("subject", "maxLength", data),
        },
      },
    },
    {
      name: "message",
      rules: {
        required: {
          value: true,
          message: getRuleErrorMessage("message", "required", data),
        },
        maxLength: {
          value: 300,
          message: getRuleErrorMessage("message", "maxLength", data),
        },
      },
    },
  ];
};
